const items = [
	{
		id: 1,
		name: "insuranceType.life"
	},
	{
		id: 2,
		name: "insuranceType.vehicle"
	},
];

export default items;